<template>
  <TruePanel class="p-3 mb-2">
    <div class="flex">
      <div class="label text-blue text-bold">
        {{ label }}
      </div>
      <div class="flex-grow text-right text-bold">
        {{ value }}
      </div>
      <div class="ml-2">
        <button type="button" @click="toggleEditor">
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <!-- EDITOR -->
    <div class="editor" v-if="editorOpen">
      <NumberInput :value="value" controls @change="handleChange"/>
      <!-- <button class="btn" @click="closeEditor">Save</button> -->
    </div>
  </TruePanel>
</template>

<script>
import TruePanel from './TruePanel.vue'
import NumberInput from './NumberInput.vue'

export default {
  components: {
    TruePanel,
    NumberInput
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: null,
      default: null,
    }
  },

  data: () => ({
    editorOpen: false,
  }),

  methods: {
    toggleEditor() {
      this.editorOpen = !this.editorOpen
    },

    openEditor() {
      this.editorOpen = true
    },

    closeEditor() {
      this.editorOpen = false
    },

    handleChange(newValue) {
      this.$emit('input', newValue)
    }
  },

}
</script>

<style scoped>
.fa-pencil {
  color: #838383;
}

.editor {
  padding-top: 1rem;
}

button {
  cursor: pointer;
  background: transparent;
  border: none;
}
</style>
